<template>
    <div class="section">
        
        <div class="columns is-centered is-mobile">
            <div class="column is-half-desktop is-two-thirds-tablet is-full-mobile has-text-centered">
                <div class="menu pronounced-bottom">
                    <p class="menu-label">Elige la empresa que vas a administrar.</p>
                    <ul class="menu-list">
                        <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="true"></b-loading>
                        <li v-for="(company,index) in companies" :index="index" :key="company.id">
                            <a :href="company.siteUrl">
                            {{company.companyName}}
                            </a>
                        </li>
                    </ul>
                </div>        
            </div>
        </div>
    </div>
</template>


<script>
import {getHandler} from "./../../../services/http.js"

export default {
    name:"SitesMenu",
    props: {
        companiesEndpoint: {
            type:String,
            default:""
        }
    },
    data(){
        return{
        companies:[],
        isLoading:false
        }
    },
    methods: {
        async loadCompanies(){
            let errMsg = {
                text:"",
                hasIcon:true,
                resource:'notify'
            }
            this.isLoading = true
            this.companies = await getHandler(this.companiesEndpoint, {success:false, error:errMsg,})
            this.isLoading = false
        }
    },
    created(){
        this.loadCompanies()
    }
}
</script>


<style lang="scss" scoped>
  @import "./../../../scss/main.scss";
    .menu{
        box-shadow: 5px 5px 8px $primary-shadow-light;
    }
    .menu-list{
        li:last-child{
            a{
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
            }
        }
    }
</style>
